/**
 * @file roleConstants.js
 * @description Constants for the Role management module within the Admin section.
 *              Includes UI label strings, data field key mappings, table column definitions,
 *              column key mappings, user-facing messages, and error message strings.
 *
 * @module roleConstants
 *
 * @exports ROLE_STRINGS           - UI label strings (e.g. "Add Role", "Edit Role").
 * @exports ROLE_KEYS              - Enum-style keys for role data fields (id, rolename).
 * @exports ROLE_TABLE_COLUMNS     - Column config array for the roles table.
 * @exports ROLE_TABLE_COLUMN_KEYS - Enum-style keys matching table column IDs.
 * @exports ROLE_MESSAGES          - User-facing success/empty-state messages.
 * @exports ROLE_ERRORS            - Error message strings for CRUD operations.
 */
export const ROLE_STRINGS = {
    ADD_ROLE: "Add Role",
    EDIT_ROLE: "Edit Role",
    ROLE_NAME: "Role Name",
    SEARCH_ROLES: "Search Roles",
};

export const ROLE_KEYS = {
    ID: "id",
    ROLE_NAME: "rolename",
};

export const ROLE_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "id", isSortable: true, label: "Role ID" },
    { id: "rolename", isSortable: true, label: "Role Name" },
    { id: "createdate", isSortable: true, label: "Create Date" },
];

export const ROLE_TABLE_COLUMN_KEYS = {
    ID: "id",
    ACTIONS: "actions",
    ROLE_NAME: "rolename",
    CREATE_DATE: "createdate"
};

export const ROLE_MESSAGES = {
    NO_ROLES: "No roles to display",
    ROLE_ADDED: "Role added successfully!",
    ROLE_UPDATED: "Role updated successfully!",
};

export const ROLE_ERRORS = {
    ADD_ROLE_ERROR: "Error adding role:",
    SAVE_ROLE_ERROR: "Error saving role:",
    UPDATE_ROLE_ERROR: "Error updating role:",
    FETCH_ROLES_ERROR: "Error fetching user roles:",
};